/* eslint-disable import/no-cycle */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
import { React, useState, useEffect } from "react";
import "./InfoPrompt.css";
import { isBrowser, isMobile } from "react-device-detect";
import create from "zustand";

const store = (set) => ({
  showInfo: true,
  setShowInfo: (showInfo) => set({ showInfo }),
});

export const useInfoPromptState = create(store);
export const InfoPromptState = useInfoPromptState.getState;

function InfoPrompt() {
  const [arMode, setArMode] = useState(false);
  const showInfo = useInfoPromptState((s) => s.showInfo);
  const setShowInfo = useInfoPromptState((s) => s.setShowInfo);
  const [info, setInfo] = useState(["", ""]);
  const [icon, setIcon] = useState(["", ""]);
  const [id, setID] = useState(["", ""]);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("ar") === "1") {
      setArMode(true);
    } else {
      setArMode(false);
    }
  }, []);
  useEffect(() => {
    if (showInfo) {
      setTimeout(() => {
        setShowInfo(false);
      }, 5000);
    }
    console.info("rito s", showInfo);
  }, [showInfo, setShowInfo]);
  useEffect(() => {
    if (arMode) {
      setInfo(["One finger drag to rotate", "Two finger drag to move"]);
      setIcon([`./assets/single_finger.svg`, `./assets/two_finger.svg`]);
      setID(["info-icon", "info-icon"]);
    } else if (isMobile) {
      setInfo(["One finger drag to rotate", "Two finger pinch to scale"]);
      setIcon([`./assets/single_finger.svg`, `./assets/pinch.png`]);
      setID(["info-icon", "info-icon"]);
    } else if (isBrowser) {
      setInfo(["Mouse drag to rotate", "Mouse zoom to scale"]);
      setIcon([`./assets/rotate.svg`, `./assets/zoom1.svg`]);
      setID(["info-icon", "info-icon-s"]);
    }
  }, [arMode]);
  if (showInfo) {
    return (
      <div
        className="InfoPromptContainer"
        onClick={() => {
          setShowInfo(false);
        }}
      >
        <div className="InfoPrompt">
          {/* <p> -- Tap to continue -- </p> */}
          <div className="Info">
            <div className="icon">
              <img src={icon[0]} alt="" id={id[0]} />
            </div>
            <p>{info[0]}</p>
          </div>
          <div className="InfoDivider" />
          <div className="Info">
            <div className="icon">
              <img src={icon[1]} alt="" id={id[1]} />
            </div>
            <p>{info[1]}</p>
          </div>
        </div>
      </div>
    );
  }
  return null;
}

export default InfoPrompt;
